module.exports = __webpack_public_path__ + "static/media/90900-Bronze.908001d8.png";